import React, { Component } from 'react';
import styled from 'styled-components';

const IPhone = styled.div`
  width: 320px;
  height: 530px;
  background: white;
  border-radius: 5px;
  padding: 20px;
  padding-bottom: 45px;
  position: fixed;
  box-shadow: 0px 2px 3px;
`
const IPhoneScreen = styled.div`
  position: relative;
  overflow-y: scroll;
  border: 1px solid black;
  height: 100%;
  background: ${props => props.background};

  &::-webkit-scrollbar {
    width: 5px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #aaa;
  }
`
const TitleBar = styled.div`
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.styles.background};
  color: ${props => props.styles.color};
`
const LoyaltyCard = styled.div`
  height: 175px;
  display: flex;
  padding: 15px;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  background: ${props => props.styles ? props.styles.background : '#537EFF'};
  color: ${props =>  props.styles ? props.styles.color : 'white'};
`
const FeaturedEvents = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`
const DayEvents = styled.div`
  padding: 20px;
`
const NotificationArea = styled.div`
  padding: 20px;
  margin-bottom: 56px;
  display: flex;
  flex-wrap: wrap;
`
const Notification = styled.div`
  display: flex;
  width:  46%;
  height: 120px;
  background-color: ${props => props.background};
  justify-content: center;
  align-items: center;
  margin: 2%;
  margin-bottom: 15px;
`
const BottomBar = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: ${props => props.background};
  overflow: hidden;
  width: 100%;
  height: 56px;
`
const NavBarItem = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
export default class IPhoneView extends Component {

  render () {
    const { theme } = this.props;

    const {
      title = {},
      loyal = {},
      card = {},
      datecircle = {},
      box = {},
      button = {},
      bottom = {},
      /*notification = {},*/
      general = {},
    } = theme;

    return (
      <IPhone>
        <IPhoneScreen background={general.background}>
          <TitleBar styles={title}>
            <div
              className="logo-upload-button"
              style={{
                backgroundImage: `url("${title.logo}")`,
              }} />
          </TitleBar>
          <LoyaltyCard styles={loyal}>
            <span style={{
              marginTop: -3,
              fontSize: 14,
              fontFamily: 'Lato-Regular',
              color: loyal.title,
            }}>LOYALTY PROGRAM</span>
            <div style={{display: 'flex', marginTop: -7}}>
              <span style={{
                fontSize: 45,
                fontFamily: 'Lato-Bold',
                color: loyal.text}}>3/</span>
              <span style={{
                fontSize: 45,
                fontFamily: 'Lato-Black',
                color: loyal.text}}>10</span>
            </div>
            <span style={{
              fontFamily: 'Lato-Regular',
              color: loyal.text,
              marginBottom: 8,
            }}>7 points remaining until $2 OFF</span>
            <div style={{
              height: 10,
              width: '90%',
              backgroundColor: 'white',
              borderRadius: 5,
            }}>
              <div style={{
                borderRadius: 5,
                width: '30%',
                height: 10,
                backgroundColor: loyal.progress,//'#2699FB'
              }} />
            </div>
            <div style={{
              marginTop: 12,
              height: 35,
              width: 99,
              borderStyle: 'solid',
              borderWidth: 3,
              borderColor: 'white',
              borderRadius: 15,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              <span style={{
                fontSize: 7,
                fontFamily: 'Arial',
                fontWeight: 'bold',
                color: 'white'
              }}> CHECK-IN</span>
            </div>
          </LoyaltyCard>
          <FeaturedEvents>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              height: 25,
              marginBottom: 10
            }}>
              <span style={{
                color: '#767676',
                fontSize: 23,
                fontWeight: 'bold'
              }}>Upcoming Events</span>
              <div style={{
                borderRadius: 10,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: button.background,
                height: 21,
                width: 67
              }}>
                <span style={{
                  color: button.text,
                  fontSize: 8,
                  fontFamily: 'Arial'
                }}>VIEW ALL</span>
              </div>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              height: 160,
              backgroundColor: card.background,
              alignItems: 'center',
              padding: 20
            }}>
              <div style={{
                height: 52,
                width: 52,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: datecircle.background,//'#3366FF'
                borderRadius: 26
              }}>
                <span style={{
                  color: datecircle.text,
                  fontSize: 18
                }}>6/6</span>
              </div>
              <span style={{
                color: card.title,
                fontSize: 29
              }}>Event Title</span>
              <span style={{
                color: card.subtitle,
                fontSize: 17
              }}>7AM - 9AM</span>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              height: 57,
              backgroundColor: box.background,
              alignItems: 'center',
              padding: 20,
              marginTop: 10
            }}>
              <div style={{
                height: 37,
                width: 37,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: datecircle.background,
                borderRadius: 18
              }}>
                <span style={{
                  color: datecircle.text,
                  fontSize: 12
                }}>6/9</span>
              </div>
              <span style={{
                color: box.title,
                fontSize: 20,
                width: '70%'
              }}>Event1</span>
              <span style={{
                color: box.title,
                fontSize: 20
              }}>></span>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              height: 57,
              backgroundColor: box.background,
              alignItems: 'center',
              padding: 20,
              marginTop: 10
            }}>
              <div style={{
                height: 37,
                width: 37,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: datecircle.background,
                borderRadius: 18
              }}>
                <span style={{
                  color: datecircle.text,
                  fontSize: 12
                }}>6/11</span>
              </div>
              <span style={{
                color: box.title,
                fontSize: 20,
                width: '70%'
              }}>Event2</span>
              <span style={{
                color: box.title,
                fontSize: 20
              }}>></span>
            </div>
          </FeaturedEvents>
          <DayEvents>
            <div className={'header'} style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div>
                <span style={{
                  color: '#767676',
                  fontSize: 23,
                  fontWeight: 'bold'
                }}>What's Happening</span><br/>
                <span style={{
                  color: '#767676',
                  fontSize: 16,
                  fontWeight: 'bold'
                }}>Monday</span>
              </div>
              <div style={{
                borderRadius: 10,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: button.background,
                height: 21,
                width: 92
              }}>
                <span style={{
                   color: button.text,
                   fontSize: 8,
                   fontFamily: 'Arial'
                }}>VIEW CALENDAR</span>
              </div>
            </div>
            <div style={{
              height: 85,
              padding: 10,
              backgroundColor: '#F8F8F8',
              marginTop: 20
            }}>
              <span>Daily Special</span>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: 15
            }}>
              <div style={{width: '19%'}}>
                <span>9AM-</span>
                <span>10AM</span>
              </div>
              <div style={{
                height: 43,
                width: '80%',
                backgroundColor: '#F8F8F8',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }} >
                <span>Event1</span>
              </div>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: 15
            }}>
              <div style={{width: '19%'}}>
                <span>1PM-</span>
                <span>3PM</span>
              </div>
              <div style={{
                height: 43,
                width: '80%',
                backgroundColor: '#F8F8F8',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }} >
                <span>Event2</span>
              </div>
            </div>
          </DayEvents>
          <NotificationArea>
            <Notification background={box.background}>
              <span style={{
                width: '50%',
                fontSize: 15,
                fontFamily: 'arial',
                fontWeight: 'bold',
                color: box.title,
                wrapWord: 'wrap',
                textAlign: 'center'
              }}>Newsletter</span>
            </Notification>
            <Notification background={box.background}>
              <span style={{
                width: '50%',
                fontSize: 15,
                fontFamily: 'arial',
                fontWeight: 'bold',
                color: box.title,
                wrapWord: 'wrap',
                textAlign: 'center'
              }}>Women of the Moose</span>
            </Notification>
            <Notification background={box.background}>
              <span style={{
                width: '50%',
                fontSize: 15,
                fontFamily: 'arial',
                fontWeight: 'bold',
                color: box.title,
                wrapWord: 'wrap',
                textAlign: 'center'
              }}>Pay Dues</span>
            </Notification>
            <Notification background={box.background}>
              <span style={{
                width: '50%',
                fontSize: 15,
                fontFamily: 'arial',
                fontWeight: 'bold',
                color: box.title,
                wrapWord: 'wrap',
                textAlign: 'center'
              }}>Friends of the Moose</span>
            </Notification>
          </NotificationArea>
          <BottomBar background={bottom.background}>
            <NavBarItem>
              <span style={{
                fontSize: 9,
                color: bottom.text
              }}>Home</span>
            </NavBarItem>
            <NavBarItem>
              <span style={{
                fontSize: 9,
                color: bottom.text
              }}>Notification</span>
            </NavBarItem>
            <NavBarItem>
              <span style={{
                fontSize: 9,
                color: bottom.text
              }}>Rewards</span>
            </NavBarItem>
            <NavBarItem>
              <span style={{
                fontSize: 9,
                color: bottom.text
              }}>Calendar</span>
            </NavBarItem>
            <NavBarItem>
              <span style={{
                fontSize: 9,
                color: bottom.text
              }}>More</span>
            </NavBarItem>
          </BottomBar>
        </IPhoneScreen>
      </IPhone>
    );
  }
}
